import React, { FC } from 'react';
import classnames from 'classnames';
import { FooterInfoBlockProps } from './props';

export const FooterInfoBlock: FC<FooterInfoBlockProps> = ({ text, isPaddingDisabled = false }) => {
  return (
    <div
      className={classnames('subscription-modal__footer-info', {
        'subscription-modal__footer-info--less-padding': isPaddingDisabled,
      })}
    >
      {text ? `${text} ` : ''}All prices are exclusive of VAT.
    </div>
  );
};
